import { render, staticRenderFns } from "./adjustOrderDetails.vue?vue&type=template&id=6ed0db83&scoped=true"
import script from "./adjustOrderDetails.vue?vue&type=script&lang=js"
export * from "./adjustOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./adjustOrderDetails.vue?vue&type=style&index=0&id=6ed0db83&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0db83",
  null
  
)

export default component.exports